import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { WechatOutlined } from '@ant-design/icons';
import { wecomLoginUtil } from '@/utils/wecom';
import { wecomLogin } from '@/services/api';

interface WecomLoginButtonProps {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
  buttonText?: string;
  buttonType?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  buttonSize?: 'large' | 'middle' | 'small';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const WecomLoginButton: React.FC<WecomLoginButtonProps> = ({
  onSuccess,
  onError,
  buttonText = '企业微信登录',
  buttonType = 'primary',
  buttonSize = 'large',
  disabled = false,
  loading = false,
  className,
  style,
}) => {
  const [isInitializing, setIsInitializing] = useState(false);

  useEffect(() => {
    // 检查是否为企业微信授权回调
    if (wecomLoginUtil.isWecomCallback()) {
      handleWecomCallback();
    }
  }, []);

  /**
   * 处理企业微信授权回调
   */
  const handleWecomCallback = async () => {
    try {
      setIsInitializing(true);
      
      // 获取登录参数
      const loginParams = wecomLoginUtil.getLoginParams();
      if (!loginParams) {
        throw new Error('获取授权参数失败');
      }
      // 调用企业微信登录接口
      const result = await wecomLogin(loginParams);

      // const result = await response.json();
      
      if (result.ret === true) {
        // 清除URL中的授权参数
        wecomLoginUtil.clearAuthParams();
        
        // 调用成功回调
        if (onSuccess) {
          onSuccess(result.data);
        }
      } else {
        throw new Error(result.msg || '企业微信登录失败');
      }
    } catch (error) {
      console.error('企业微信登录失败:', error);
      message.error('企业微信登录失败，请重试'+error);
      
      // 清除URL中的授权参数
      wecomLoginUtil.clearAuthParams();
      
      // 调用错误回调
      if (onError) {
        onError(error);
      }
    } finally {
      setIsInitializing(false);
    }
  };

  /**
   * 处理企业微信登录点击
   */
  const handleWecomLogin = async () => {
    try {
      setIsInitializing(true);
      
      // 初始化企业微信配置
      // await wecomLoginUtil.initConfig();
      
      // 生成授权URL并跳转
      const authUrl = await wecomLoginUtil.generateAuthUrl();
      window.location.href = authUrl;
    } catch (error) {
      console.error('启动企业微信登录失败:', error);
      message.error('启动企业微信登录失败，请重试');
      
      if (onError) {
        onError(error);
      }
    } finally {
      setIsInitializing(false);
    }
  };

  return (
    <Button
      type={buttonType}
      size={buttonSize}
      icon={<WechatOutlined />}
      onClick={handleWecomLogin}
      disabled={disabled || isInitializing}
      loading={loading || isInitializing}
      className={className}
      style={style}
      block
    >
      {buttonText}
    </Button>
  );
};

export default WecomLoginButton;
